import { render, staticRenderFns } from "./PasswordResetInit.vue?vue&type=template&id=6154da83&scoped=true"
import script from "./PasswordResetInit.vue?vue&type=script&lang=js"
export * from "./PasswordResetInit.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetInit.vue?vue&type=style&index=0&id=6154da83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6154da83",
  null
  
)

export default component.exports